module.exports = __webpack_public_path__ + "img/hr-brown-fluff-17.fb476210.png";